import axios, { InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { stores } from '../context';

// EN: Create a single instance of axios for all API requests.
const $api = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_API_URL,
});

// EN: Request interceptor function
export const requestInterceptor = (config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('token');
  
  // EN: Ensure token exists and is a valid non-empty string (not "undefined" or "null")
  if (token && token !== 'undefined' && token !== 'null') {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// EN: Response interceptors functions
export const responseInterceptor = (response: AxiosResponse) => response;

export const responseErrorInterceptor = (error: any) => {
  if (error.response?.status === 401) {
    if (stores.user.isAuth) {
      stores.user.logout();
    }
  }
  return Promise.reject(error);
};

// EN: Register interceptors
$api.interceptors.request.use(requestInterceptor);
$api.interceptors.response.use(responseInterceptor, responseErrorInterceptor);

export { $api };